import { FroalaEditorFunctionality } from './FroalaEditorFunctionality';
import * as React from 'react';

export class FroalaEditorA extends FroalaEditorFunctionality {    
  render () {
    const that: any = this 
    return (
      <a ref={el => that.el = el}>{this.props.children}</a>
    );
  }
}